import * as React from 'react';
import { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { createDateRangeFromType, DateRange } from 'owa-datetime-utils';
import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { InlineCalendar } from 'owa-datepicker';
import { logUsage } from 'owa-analytics';
import { observer } from 'mobx-react-lite';
import { OwaDate } from 'owa-datetime';
import { updateSelectedDate } from 'owa-calendar-surface';

let styles = require('./DayPickerRenderer.scss');

/**
 * Published calendar day picker renderer properties
 */
export interface DayPickerRendererProps {
    surfaceStore: CalendarSurfaceStore;
    onDateRangeChange: (dateRange: DateRange) => void;
}

/**
 * Published calendar day picker renderer
 */
export default observer(function DayPickerRenderer(props: DayPickerRendererProps) {
    const { surfaceStore } = props;
    return (
        <div className={styles.dayPickerWrapper}>
            <InlineCalendar
                value={surfaceStore.selectedDate}
                showGoToToday={false}
                dateRangeType={validateMiniMonthDateRangeType(surfaceStore.dateRangeType)}
                onSelectDate={onDayPickerDateSelected(props)}
                showMonthPickerAsOverlay={true}
                isMonthPickerVisible={false}
                highlightCurrentMonth={false}
                highlightSelectedMonth={true}
                firstDayOfWeek={surfaceStore.userOptions.weekStartDay}
                showWeekNumbers={surfaceStore.userOptions.showWeekNumbers}
                firstWeekOfYear={surfaceStore.userOptions.firstWeekOfYear}
                workWeekDays={surfaceStore.userOptions.workDays}
            />
        </div>
    );
});

/**
 * Called when a date is selected
 */
const onDayPickerDateSelected = (props: DayPickerRendererProps) => (selectedDate: OwaDate) => {
    const { surfaceStore } = props;
    const newDateRange = createDateRangeFromType(
        surfaceStore.dateRangeType,
        selectedDate,
        surfaceStore.userOptions.weekStartDay,
        surfaceStore.userOptions.workDays,
        1 // TODO VSO 80763: Implement flexible day view store prop in published calendar surface store
    );
    const { onDateRangeChange } = props;
    onDateRangeChange?.(newDateRange);
    logUsage('PublishedCalSelectDate');
    updateSelectedDate(selectedDate, surfaceStore);
};

/**
 * Called when a date range is selected
 */
function validateMiniMonthDateRangeType(dateRangeType: DateRangeType): DateRangeType {
    // When Month view is active, Mini-Month should allow single day selection, emulating Day view's behavior
    if (dateRangeType === DateRangeType.Month) {
        dateRangeType = DateRangeType.Day;
    }
    return dateRangeType;
}
